import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Output,
    input,
    signal,
    inject,
    computed,
    effect,
    DestroyRef,
    ChangeDetectorRef
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CustomerService } from "../../services/customer.service";


@Component({
    selector: 'app-search-customer',
    imports: [FormsModule],
    templateUrl: './search-customer.component.html',
    standalone: true,
    styleUrls: ['./search-customer.component.scss']
})
export class SearchCustomerComponent {
    private customerService = inject(CustomerService);
    private elementRef = inject(ElementRef);
    private destroyRef = inject(DestroyRef);
    private cdr = inject(ChangeDetectorRef);

    customerName = input<string | undefined>(undefined);
    customerId = input<number | undefined>(undefined);
    required = input<boolean>(true);
    disabled = input<boolean>(false);

    @Output() selectedCustomerId = new EventEmitter<number>();

    isListVisible = signal<boolean>(false);
    filterValue = signal<string>('');
    searchParams = signal({
        customerName: '',
    });

    customers = computed(() => this.customerService.all());
    selectedCustomer = computed(() => this.customerService.active());

    constructor() {
        effect(() => {
            const id = this.customerId();
        });

        effect(() => {
            const selected = this.selectedCustomer();
            if (selected?.customerName) {
                this.filterValue.set(selected.customerName);
            }
        });

        effect(() => {
            const name = this.customerName();
            if (name && name !== '') {
                this.filterValue.set(name);
            }
        });
    }

    onInputChange(value: string): void {
        this.filterValue.set(value);
        this.searchParams.set({
            ...this.searchParams(),
            customerName: value.trim(),
        });

        if (value.trim()) {
            this.customerService
                .searchCustomers(this.searchParams(), true)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe({
                    next: () => {
                        this.isListVisible.set(true);
                        this.cdr.detectChanges();
                        console.log('Customers in component after update:', this.customers());
                    },
                    error: (error) => {
                        console.error('Search error:', error);
                        this.isListVisible.set(false);
                    }
                });
        } else {
            this.clearSelection();
        }
    }

    onOptionSelected(customerId: number): void {
        this.isListVisible.set(false);
        this.selectedCustomerId.emit(customerId);

        const selectedCustomer = this.customers().find(customer => customer.id === customerId);
        if (selectedCustomer) {
            this.filterValue.set(selectedCustomer.customerName);
        }
    }

    @HostListener('document:click', ['$event'])
    clickOutsideDropdown(event: Event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isListVisible.set(false);
            if (!this.selectedCustomer() && this.filterValue() === '') {
                this.clearSelection();
            }
        }
    }

    clearSelection(): void {
        this.filterValue.set('');
        this.searchParams.set({
            customerName: '',
        });
        this.customerService.initial();
        this.selectedCustomerId.emit(-1);
    }

    selectAll(event: MouseEvent): void {
        (event.target as HTMLInputElement).select();
    }
}